import querystring from 'querystring';
import api from '../api';

class DataServiceEnrollment {
  getEnrollmentByUserAndCourse(id_user, id_company_course, query = {}) {
    const queryParams = querystring.stringify(query);
    return api.get(
      `/enrollments/${id_user}/${id_company_course}${
        queryParams ? `?${queryParams}` : ''
      }`
    );
  }
  addEnrollment(data, query) {
    return api.post(`enrollments?${querystring.stringify(query)}`, data);
  }

  addSolicitationEnrollment(data, query) {
    const queryParams = query ? `?${querystring.stringify(query)}` : '';
    return api.post(`enrollments-solicitation${queryParams}`, data);
  }

  getSolicitationEnrollments(query) {
    const queryParams = query ? `?${querystring.stringify(query)}` : '';
    return api.get(`enrollments-solicitation${queryParams}`);
  }

  updateSolicitationEnrollment(id, data) {
    return api.put(`enrollments-solicitation/${id}`, data);
  }

  getCompanyCourseCombo() {
    return api.get('/list-company-course');
  }

  getCompanyCourseComboRecycling() {
    return api.get('/list-company-course-recycling');
  }

  getEnrollment(id, querys) {
    return api.get(`enrollments/${id}?${querystring.stringify(querys)}`);
  }

  deleteEnrollment(id) {
    return api.delete(`enrollments/${id}`);
  }

  getUserCompletedCourses(id_user, id_course) {
    const filter = { filter_course_id: id_course };
    return api.get(
      `certificates/student-fineshed-courses/${id_user}?${querystring.stringify(
        filter
      )}`
    );
  }

  countByUserEnrollments(id_user) {
    return api.get(`/enrollments/${id_user}/countEnrollments`);
  }

  lockEnrollment(id_user, id_company, id_company_course, query = {}) {
    const queryParams = querystring.stringify(query);
    return api.patch(
      `enrollments/${id_company_course}/${id_user}/${id_company}/lock${
        queryParams ? `?${queryParams}` : ''
      }`
    );
  }

  unlockEnrollment(id_user, id_company, id_company_course, query = {}) {
    const queryParams = querystring.stringify(query);
    return api.patch(
      `enrollments/${id_company_course}/${id_user}/${id_company}/unlock${
        queryParams ? `?${queryParams}` : ''
      }`
    );
  }
}

export default new DataServiceEnrollment();
